/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Type_ContractInputs */

const en_doc_type_contract = /** @type {(inputs: Doc_Type_ContractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contract / Agreement`)
};

const id_doc_type_contract = /** @type {(inputs: Doc_Type_ContractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontrak / Perjanjian`)
};

/** @type {(inputs: Doc_Type_ContractInputs) => LocalizedString} */
const es_doc_type_contract = en_doc_type_contract;

/** @type {(inputs: Doc_Type_ContractInputs) => LocalizedString} */
const fr_doc_type_contract = en_doc_type_contract;

/** @type {(inputs: Doc_Type_ContractInputs) => LocalizedString} */
const de_doc_type_contract = en_doc_type_contract;

/** @type {(inputs: Doc_Type_ContractInputs) => LocalizedString} */
const ja_doc_type_contract = en_doc_type_contract;

/** @type {(inputs: Doc_Type_ContractInputs) => LocalizedString} */
const zh_doc_type_contract = en_doc_type_contract;

/** @type {(inputs: Doc_Type_ContractInputs) => LocalizedString} */
const ar_doc_type_contract = en_doc_type_contract;

/** @type {(inputs: Doc_Type_ContractInputs) => LocalizedString} */
const it_doc_type_contract = en_doc_type_contract;

/** @type {(inputs: Doc_Type_ContractInputs) => LocalizedString} */
const ru_doc_type_contract = en_doc_type_contract;

/** @type {(inputs: Doc_Type_ContractInputs) => LocalizedString} */
const pt_doc_type_contract = en_doc_type_contract;

/** @type {(inputs: Doc_Type_ContractInputs) => LocalizedString} */
const ko_doc_type_contract = en_doc_type_contract;

/**
* | output |
* | --- |
* | "Contract / Agreement" |
*
* @param {Doc_Type_ContractInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const doc_type_contract = /** @type {((inputs?: Doc_Type_ContractInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Type_ContractInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_type_contract(inputs)
	if (locale === "es") return es_doc_type_contract(inputs)
	if (locale === "fr") return fr_doc_type_contract(inputs)
	if (locale === "de") return de_doc_type_contract(inputs)
	if (locale === "ja") return ja_doc_type_contract(inputs)
	if (locale === "zh") return zh_doc_type_contract(inputs)
	if (locale === "ar") return ar_doc_type_contract(inputs)
	if (locale === "id") return id_doc_type_contract(inputs)
	if (locale === "it") return it_doc_type_contract(inputs)
	if (locale === "ru") return ru_doc_type_contract(inputs)
	if (locale === "pt") return pt_doc_type_contract(inputs)
	return ko_doc_type_contract(inputs)
});